import { ofType } from 'redux-observable';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { login, loginSuccess, loginFailure } from '../slices/userSlice';

export const loginEpic = (action$, state$) =>
  action$.pipe(
    ofType(login.type),
    mergeMap((action) =>
      ajax({
        url: '/api/google_login_code/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => loginSuccess({ data: res.response.data })),
        catchError((err) =>
          of(
            loginFailure({
              msg:
                err?.response?.msg ||
                err?.message ||
                '網路或伺服器錯誤',
              raw: err?.response || null,
            })
          )
        )
      )
    )
  );
